/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
import { Shoot, ShootZig, ShootPlasma, ShootRotate, ShootRocket } from "./../Entities/Shoots"

import { keyManager } from "./KeyManager"
import { TextManager } from './TextManager';
import { currentAmmochosen, setAmmochosen } from "./../modules/storage"
export class SceneGlobales {
    constructor() {
        this.keyManager = new keyManager()
        this.textManager = new TextManager()
    }

    prepareSpaceship(GameData) {
        const SpaceshipChoosed = GameData.spaceship
        this.player = Object.assign({}, SpaceshipChoosed);
        Object.entries(this.player).forEach(([key, value]) => {
            if (key === "speed" || key === "level" || key === "fireCapacity" || key === "maxFuel" || key === "resilience" || key === "maxShields" || key === "maxWeapons") {
                this.player[key] = parseInt(value);
            } else if (key === "spritePhoto") {
                this.player["sprite_photo"] = value;
                delete this.player["spritePhoto"];
            }
        });
        this.player["scaleX"] = 1;
        this.player["scaleY"] = 1;



    }

    getPlayer() {
        return this.player

    }

    prepareWeapons(GameData) {
        const shootclassmap = {
            "Shoot": Shoot,
            "ShootZig": ShootZig,
            "ShootPlasma": ShootPlasma,
            "ShootRotate": ShootRotate,
            "ShootRocket": ShootRocket,
        };
        const weaponschecked = GameData.weapons
        this.weapons = weaponschecked.map(weaponElement => {
            const weapon = {};
            Object.entries(weaponElement).forEach(([key, value]) => {
                if (key === "level" || key === "ammo") {
                    value = parseInt(value);
                } else if (key === "class") {
                    value = shootclassmap[value];
                } else if (key === "speed") {
                    Object.assign(weapon, {
                        speedX: parseInt(value[0]),
                        speedY: parseInt(value[1])
                    });
                    return;
                } else if (key === "name") {
                    Object.assign(weapon, {
                        name: value,
                        bar_key: `${value} bar`,
                        audio_key: `${value} wav`
                    });
                    return;
                } else if (key === "barPhoto") {
                    weapon["bar_photo"] = value;
                    return;
                } else if (key === "spritePhoto") {
                    weapon["sprite_photo"] = value;
                    return;
                }
                weapon[key] = value;
            });
            Object.assign(weapon, {
                scaleX: 1,
                scaleY: 1,
                anime_key: null,
                ammo_key: Math.floor(Math.random() * 10000)
            });

            return weapon;
        });

        this.maxshoots = weaponschecked.length;

    }
    getWeapons() {
        return this.weapons
    }
    getMaxShoots() {
        return this.maxshoots
    }
    prepareShields(GameData) {

        const shieldschecked = GameData.shields
        this.shields = shieldschecked.map(shieldElement => {
            const shield = {};
            Object.entries(shieldElement).forEach(([key, value]) => {
                if (key === "level") {
                    value = parseInt(value);
                } else if (key === "name") {
                    Object.assign(shield, {
                        name: value,
                        bar_key: `${value} bar`,
                        audio_key: `${value} wav`,
                        anime_key: value
                    });
                    return;
                } else if (key === "barPhoto") {
                    shield["bar_photo"] = value;
                    return;
                } else if (key === "spritePhoto") {
                    shield["sprite_photo"] = value;
                    return;
                }
                shield[key] = value;
            });
            Object.assign(shield, {
                scaleX: 1,
                scaleY: 1
            });

            return shield;
        });

        this.maxshields = shieldschecked.length;

    }
    getShields() {
        return this.shields
    }
    getMaxShields() {
        return this.maxshields
    }
    prepareRepairekit(GameData) {

        const repairekitschecked = GameData.repairekits
        this.maxrepairekit = repairekitschecked.length;
        this.repairekits = repairekitschecked.map(repairekitElement => {
            const repairekit = {};
            Object.entries(repairekitElement).forEach(([key, value]) => {
                if (key === "name") {
                    Object.assign(repairekit, {
                        bar_key: `${value} bar`,
                        audio_key: `${value} wav`
                    });
                    return;
                } else if (key === "barPhoto") {
                    repairekit["bar_photo"] = value;
                    return;
                }
                repairekit[key] = value;
            });

            return repairekit;
        });
    }
    getRepairekits() {
        return this.repairekits
    }
    getMaxRepairekits() {
        return this.maxrepairekit
    }
    prepare(GameData) {
        this.prepareSpaceship(GameData)
        this.prepareWeapons(GameData)
        this.prepareShields(GameData)
        this.prepareRepairekit(GameData)
    }
    static setCapacity(capacity) {
        this.capacity = capacity
    }
    static getCapacity() {
        return this.capacity
    }
    checkAmmoColor(weapons, specificammoText, ammoText, shootchosen) {
        if (currentAmmochosen(weapons[shootchosen].ammo_key) < 0) {
            this.textManager.setTextOnScene(specificammoText[shootchosen], 0);
        } else {
            this.textManager.setTextOnScene(specificammoText[shootchosen], `${currentAmmochosen(weapons[shootchosen].ammo_key)}`);
        }
        if (currentAmmochosen(weapons[shootchosen].ammo_key) <= weapons[shootchosen].ammo / 4) {
            specificammoText[shootchosen].setTint(0xff0000);
        } else if (currentAmmochosen(weapons[shootchosen].ammo_key) <= weapons[shootchosen].ammo / 2) {
            specificammoText[shootchosen].setTint(0xffff00);
        }
        this.textManager.setTextOnScene(ammoText, `${weapons[shootchosen].name}: ${currentAmmochosen( weapons[shootchosen].ammo_key)}`);
        ammoText.setTint(0xffffff);
        if (currentAmmochosen(weapons[shootchosen].ammo_key) <= weapons[shootchosen].ammo / 4) {
            ammoText.setTint(0xff0000);
        } else if (currentAmmochosen(weapons[shootchosen].ammo_key) <= weapons[shootchosen].ammo / 2) {
            ammoText.setTint(0xffff00);
        }
    }
    AvoidOutOfBoundries(scene, player) {
        const BOUNDRIES = {
            OutBoundryLeftAndUP: 5,
            InBoundryLeftAndUP: 6,
            OutBoundryDowm: 230,
            InBoundryDown: 231
        };
        if (player.x <= BOUNDRIES.OutBoundryLeftAndUP) {
            player.x = BOUNDRIES.InBoundryLeftAndUP;
        }
        if (player.x >= scene.game.config.width - BOUNDRIES.OutBoundryLeftAndUP) {
            player.x = scene.game.config.width - BOUNDRIES.InBoundryLeftAndUP;
        }
        if (player.y <= BOUNDRIES.OutBoundryLeftAndUP) {
            player.y = BOUNDRIES.InBoundryLeftAndUP;
        }
        if (player.y >= scene.game.config.height - BOUNDRIES.OutBoundryDowm) {
            player.y = scene.game.config.height - BOUNDRIES.InBoundryDown;
        }
    }

    reloadShoot(scene, sfx) {
        if (SceneGlobales.getCapacity() > 10 && scene.time.now - scene.lastShotTime < 5000) {
            scene.player.setTint(0xff0000);
            sfx.reloadshoot.play();
            // Stop shooting for 2 seconds
            const spacebar = this.keyManager.createKey(scene,
                Phaser.Input.Keyboard.KeyCodes.SPACE
            );
            spacebar.enabled = false;
            scene.time.delayedCall(2000, () => {
                spacebar.enabled = true;
                // remove tint
                scene.player.clearTint();
            });
            SceneGlobales.setCapacity(0);
        } else if (SceneGlobales.getCapacity() > 10 && scene.time.now - scene.lastShotTime > 5000) {
            SceneGlobales.setCapacity(0);
        }
    }
    collisoinShootEnemy(scene, enemy, shoot, sfx, player) {
        if (enemy) {
            if (enemy.onDestroy !== undefined) {
                enemy.onDestroy();
            }
            const OPTIONS = {
                BOSS: {
                    "COUNTER": "bosscounter"
                },
                ENEMY: {
                    "LEVEL": "enemylevel",
                    "KEY": "enemykey"
                },
                SHOOT: {
                    "LEVEL": "shootlevel"
                }
            }
            if (enemy.getData(OPTIONS.ENEMY.KEY) == "boss") {
                sfx.explosions[1].play();
                enemy.body.velocity.y = 0;
                enemy.body.velocity.x = 0;
                enemy.setData(`${OPTIONS.BOSS.COUNTER}`, enemy.getData(OPTIONS.BOSS.COUNTER) + 1);
                //console.log("boss increase ", BossEnemy.getbossincrease())
                if (
                    enemy.getData(OPTIONS.BOSS.COUNTER) >=
                    10 * enemy.getData(OPTIONS.ENEMY.LEVEL)
                ) {
                    enemy.explode(true, this);
                    enemy.setData(`${OPTIONS.BOSS.COUNTER}`, 0);
                    //BossEnemy.setbossincrease(BossEnemy.getbossincrease() + 1);
                } else {
                    enemy.setTint(0xff0000);
                    setTimeout(() => enemy.setTint(0xffffff), 100);
                }
                shoot.setData(`${OPTIONS.SHOOT.LEVEL}`, shoot.getData(`${OPTIONS.SHOOT.LEVEL}`) - 1);
                if (shoot.getData(`${OPTIONS.SHOOT.LEVEL}`) == 0) {
                    shoot.destroy();
                }
            } else {
                enemy.setData(OPTIONS.ENEMY.LEVEL, enemy.getData(OPTIONS.ENEMY.LEVEL) - 1);
                if (enemy.getData(OPTIONS.ENEMY.LEVEL) == 0) {
                    enemy.explode(true, scene);
                }
                shoot.setData(OPTIONS.SHOOT.LEVEL, shoot.getData(OPTIONS.SHOOT.LEVEL) - 1);
                if (shoot.getData(OPTIONS.SHOOT.LEVEL) == 0) {
                    shoot.destroy();
                }
            }
            player.setCurrentPlayerScore(player.getCurrentPlayerScore() + 1);
            if (player.getCurrentPlayerScore() > parseInt(player.getPlayerHighScore(), 10)) {
                player.setPlayerHighScore(player.getCurrentPlayerScore());
            }
        }

    }
    collisoinShieldsEnemyLaser(scene, enemyLaser, shield, sfx) {
        const OPTIONS = {
            SHIELD: {
                "LEVEL": "shieldlevel"
            }
        }
        sfx.shieldsColliders.play();
        if (shield) {
            shield.setData(OPTIONS.SHIELD.LEVEL, shield.getData(OPTIONS.SHIELD.LEVEL) - 1);
            if (shield.getData(OPTIONS.SHIELD.LEVEL) == 0) {
                shield.destroy();
            }
            if (enemyLaser) {
                enemyLaser.destroy();
            }
        }

    }
    collisoinShieldsEnemy(scene, enemy, shield, sfx) {
        const OPTIONS = {
            ENEMY: {
                "LEVEL": "enemylevel",
            },
            SHIELD: {
                "LEVEL": "shieldlevel"
            }
        }
        sfx.shieldsColliders.play();
        if (shield) {
            shield.setData(OPTIONS.SHIELD.LEVEL, shield.getData(OPTIONS.SHIELD.LEVEL) - 1);
            if (shield.getData(OPTIONS.SHIELD.LEVEL) == 0) {
                shield.destroy();
            }
            enemy.setData(OPTIONS.ENEMY.LEVEL, enemy.getData(OPTIONS.ENEMY.LEVEL) - 1);
            if (enemy.getData(OPTIONS.ENEMY.LEVEL) == 0) {
                enemy.explode(true, scene);
            }
        }

    }

    collisoinPlayerEnemy(scene, enemy, player) {
        const OPTIONS = {
            PLAYER: {
                "RESILIENCE": "resilience",
                "ISDEAD": "isDead"
            },
        }
        if (player.getData(OPTIONS.PLAYER.RESILIENCE) <= 0) {
            if (!player.getData(OPTIONS.PLAYER.ISDEAD) && !enemy.getData(OPTIONS.PLAYER.ISDEAD)) {
                scene.firetail.firetailDestroy();
                scene.game.sound.pauseAll();
                player.explode(false, scene);
                enemy.explode(true, scene);
                scene.scene.start("SceneScores", { mode: scene.mode, isDead: true, player: player });
            }
        } else {
            player.setTint(0xff0000);
            setTimeout(() => {
                player.setTint(0xffffff);
            }, 500);
            enemy.explode(true, scene);
            player.setCurrentPlayerScore(player.getCurrentPlayerScore() + 1);
            player.setData(OPTIONS.PLAYER.RESILIENCE, player.getData(OPTIONS.PLAYER.RESILIENCE) - 1);
        }

    }

    collisoinPlayerEnemyLasers(scene, player, laser) {
        const OPTIONS = {
            PLAYER: {
                "ISDEAD": "isDead"
            },
        }
        if (!player.getData(OPTIONS.PLAYER.ISDEAD) && !laser.getData(OPTIONS.PLAYER.ISDEAD)) {
            scene.firetail.firetailDestroy();
            scene.game.sound.pauseAll();
            laser.destroy();
            player.explode(false, scene);
            scene.scene.start("SceneScores", { mode: scene.mode, isDead: true, player: player });
        }
    }
    createGroup(scene) {
        return scene.add.group();
    }
    createEntitesGroup(scene) {
        scene.enemies = this.createGroup(scene);
        scene.enemyLasers = this.createGroup(scene);
        scene.shoots = this.createGroup(scene)
        scene.shields = this.createGroup(scene)

    }



















}